import React from "react";

const AnalyticsComponent = () => {
  return <div>Under Development</div>;
};

export default AnalyticsComponent;
